import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {
  Area,
  Challenge,
  ChallengeType,
  CreateIdeaChallenge,
  CreateIdeaCountryInput,
  CreateIdeaGQL,
  CreateIdeaInput,
  GetAreasGQL,
  GetAreasQuery,
  GetChallengesByLanguageGQL,
  GetChallengesByLanguageQuery,
  GetChallengesGQL,
  IdeaExpectation,
} from '../../../generated/graphql';
import {Apollo, QueryRef} from 'apollo-angular';
import {BaseComponent} from '../../base/base.component';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {EmitEvent, EventBusService, Events} from '../../service/event-bus.service';
import {IdeaAttachmentService} from '../../service/idea-attachment.service';
import {CountryCard, CountryUnity, CountryUnityService} from '../../service/country-unity.service';

declare var $: any;

@Component({
  selector: 'app-register-idea',
  templateUrl: './register-idea.component.html',
  styleUrls: ['./register-idea.component.scss']
})
export class RegisterIdeaComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  // anexos selecionados no cadastro; enviados depois que a ideia é criada
  attachments: File[] = [];


  subscription: Subscription;
  page = 'challenge';

  model: CreateIdeaInput = new CreateIdeaInput();
  modelAuthorDetail: any = {};

  modelEmailConfirm = null;

  challenges: Challenge[] = [];
  challengesQuery: QueryRef<GetChallengesByLanguageQuery>;

  countries: Observable<CountryCard[]>;
  countriesUnity: Observable<CountryUnity[]>;
  selectedCountry: CountryCard;

  areas: Array<Area> = [];
  areasQuery: QueryRef<GetAreasQuery>;

  modelExpectations: any = [
    {isSelect: false, expectation: 'finance', expectationDescription: ''},
    {isSelect: false, expectation: 'productive', expectationDescription: ''},
    {isSelect: false, expectation: 'sustainability', expectationDescription: ''}
  ];

  recordStream = false;

  constructor(public router: Router,
              public translate: TranslateService,
              private eventbus: EventBusService,
              private apollo: Apollo,
              private getChallengesGQL: GetChallengesGQL,
              private getAreasGQL: GetAreasGQL,
              private getChallengesByLanguageGQL: GetChallengesByLanguageGQL,
              private createIdeaGQL: CreateIdeaGQL,
              private ideaAttachmentService: IdeaAttachmentService,
              private countryUnityService: CountryUnityService) {
    super(router, translate);
    this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      $(() => {
        this.challengesQuery.refetch({language: localStorage.getItem('culture')});
      });
    });
  }

  ngOnDestroy(): void {
    $('.header').removeClass('d-none');
    $('.footer').removeClass('d-none');
    const newAuthor = $('#newAuthor');
    if (newAuthor[0]) {
      newAuthor.remove();
    }
  }

  ngOnInit(): void {
    $('.header').addClass('d-none');
    $('.footer').addClass('d-none');
    this.recordStream = this.handlerRegister();
    this.model.authors = [];
    this.challengesQuery = this.getChallengesByLanguageGQL.watch({language: localStorage.getItem('culture')});
    this.getAreas();
    this.challengesQuery.valueChanges.subscribe(({data}) => {
      this.challenges = data.getChallengesByLanguage as Challenge[];
      this.model.challenge = new CreateIdeaChallenge();
      this.model.challenge!.language = localStorage.getItem('culture');
      if (this.challenges.length === 1) {
        this.model.challenge!.id = this.challenges[0].id
        this.model.challenge!.type = this.challenges[0].type as ChallengeType;
      }
    });
    this.countries = this.countryUnityService.getCountryCards();
  }

  ngAfterViewInit() {
  }

  handlerRegister() {
    return this.router.url === '/register';
  }

  onBackModal(page: string) {
    this.page = page;
  }

  onNextModal(page: string) {
    this.page = page;
    if (page === 'finish') {
      setTimeout(() => {
        $('.idea-finish_col-primary').css('max-width', '100%');
        $('.idea-finish_col-secondary').css('border-radius', '10px 0 0 10px');
      }, 250);
      setTimeout(() => {
        $('.idea-finish_col-secondary_padding').css('opacity', '1');
      }, 500);
    }
    if (page === 'challenge') {
      $('#idea').modal('hide');
      this.router.navigate(['/']);
    }
  }

  // STEP 1
  stepOneChallenge(id: string, type: ChallengeType) {
    this.model.challenge = {id, type, language: localStorage.getItem('culture')};
  }

  onStepSaveOne() {
    if (this.isNullOrUndefined(this.model.challenge?.id)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('challengeSelect'));
      return;
    }

    const {type: challengeType, id: challengeId} = this.model.challenge

    challengeType === 'personalized'
      ? this.router.navigate(['register-challenge-idea', challengeId])
      : this.onNextModal('description');
  }

  // STEP 2
  onChangeExpectation(x: any) {
    x.isSelect = !x.isSelect;
    if (!x.isSelect) {
      x.expectationDescription = null;
    }
  }

  onStepSaveSecond() {
    const arrValidateFields = [
      {value: this.model.title, text: this.translate.instant('ideaMaker.ideaTitle') + ', <br />'},
      {value: this.model.description, text: this.translate.instant('ideaMaker.ideaDesc') + ', <br />'}
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + `<br><br> ${stringError}`);
      return;
    }

    // EXPECTATION
    const expectations = this.modelExpectations.filter(x => x.isSelect);
    const expectationsEmpty = expectations.filter((x) => this.isNullOrUndefined(x.expectationDescription));
    if (!this.isNullOrUndefined(expectationsEmpty)) {
      const arrValidateFieldsExpectation = [];
      expectationsEmpty.map((x) => {
        arrValidateFieldsExpectation.push({
          value: x.expectationDescription,
          text: this.translate.instant(x.expectation) + ' <br />'
        });
      });
      const stringErrorExpectation = this.validateField(arrValidateFieldsExpectation);
      if (!super.isNullOrUndefined(stringErrorExpectation)) {
        this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + `<br><br> ${stringErrorExpectation}`);
        return;
      }
    }
    if (!this.isNullOrUndefined(expectations)) {
      this.model.expectation = [];
      expectations.map((x) => {
        const a: IdeaExpectation = new IdeaExpectation();
        a.expectation = x.expectation;
        a.expectationDescription = x.expectationDescription;
        a.challengeLanguage = this.translate.currentLang === 'es' ? 'es-ES' : 'pt-BR';
        this.model.expectation.push(a);
      });
    }

    // DECLARA AUTHORS UMA LISTA VAZIA ANTES DE IR PARA O STEP
    this.model.authors = [];
    this.onNextModal('author');
  }

  validateCpf(cpf: string): boolean {
    const cleanedCpf = cpf.replace(/\D/g, '');
  
    if (cleanedCpf.length !== 11) return false;
  
    if (/^(\d)\1{10}$/.test(cleanedCpf)) return false;
  
    const calculateVerifier = (cpf: string, isSecondVerifier: boolean): number => {
      const digits = cpf.split("").map(Number);
      const weight = isSecondVerifier ? [11, 10, 9, 8, 7, 6, 5, 4, 3, 2] : [10, 9, 8, 7, 6, 5, 4, 3, 2];
  
      const sum = digits
        .slice(0, isSecondVerifier ? 10 : 9)
        .reduce((acc, digit, idx) => acc + digit * weight[idx], 0);
  
      const remainder = sum % 11;
      return remainder < 2 ? 0 : 11 - remainder;
    };
  
    const firstVerifier = calculateVerifier(cleanedCpf.slice(0, 9), false);
    const secondVerifier = calculateVerifier(cleanedCpf.slice(0, 10), true);
  
    if (firstVerifier !== parseInt(cleanedCpf[9], 10) || secondVerifier !== parseInt(cleanedCpf[10], 10)) {
      return false;
    }
  
    return true;
  }

  // STEP 3
  onStepSaveThree() {
    const arrValidateFields = [
      {value: this.model.authorName, text: this.translate.instant('author.name') + ', <br />'},
      // {value: this.model.document, text: this.translate.instant('author.document') + ', <br />'},
      {value: this.model.re, text: 'RE, <br />'},
      {value: this.model.turn, text: this.translate.instant('author.period') + ', <br />'},
      {value: this.model.managerName, text: this.translate.instant('author.superior') + ', <br />'},
      // {value: this.model.phone, text: this.translate.instant('author.phone') + ', <br />'},
      // {value: this.model.phoneExtensionLine, text: this.translate.instant('author.cell') + ', <br />'},
      // {value: this.model.costCenter, text: this.translate.instant('author.costCenter') + ', <br />'},
      {value: this.model.contactHour, text: this.translate.instant('author.bestTime') + '<br />'}
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + `<br><br> ${stringError}`);
      return;
    }

    // if (!this.validateCpf(this.model.document)) {
    //   this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + ' CPF inválido ');
    //   return;
    // }

    this.onNextModal('unity');
  }

  onAddAuthor() {
    if (!this.isEMailValid(this.modelAuthorDetail.email)) {
      return;
    }

    // if (!this.validateCpf(this.modelAuthorDetail.cpf)) {
    //   this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + ' CPF inválido ');
    //   return;
    // }
  
    if (!this.model.authors) {
      this.model.authors = [];
    }
    const e = this.model.authors?.filter((x) => x === this.modelAuthorDetail.name);
    if (e.length === 0) {
      this.model.authors.push({
        name: this.modelAuthorDetail.name,
        re: this.modelAuthorDetail.re,
        cpf: this.modelAuthorDetail.cpf,
        costCenter: this.modelAuthorDetail.costCenter,
        jobRole: this.modelAuthorDetail.jobRole,
        area: this.modelAuthorDetail.area,
        email: this.modelAuthorDetail.email,
      });
      this.modelAuthorDetail = {};
    }
  }

  onRemoveAuthor(i: number) {
    this.confirmMessage(this.translate.instant('attention'), 'Deseja realmente remover o author?', () => {
      this.model.authors.splice(i, 1);
    });
  }

  // STEP 4
  onGetUnityByCountry(card: CountryCard) {
    this.selectedCountry = card;
    this.countriesUnity = this.countryUnityService.getUnities(card);
    this.model.unity = null;
    this.model.country = null;
  }

  // A ideia grava o país real da unidade, inclusive em "Unidades Internacionais".
  onChangeUnity(unity: CountryUnity) {
    const countryIf: CreateIdeaCountryInput = {id: unity.countryId};
    this.model.country = countryIf;
    this.model.unity = {id: unity.id};
  }

  onStepSaveFour() {
    if (this.isNullOrUndefined(this.model.unity) || this.isNullOrUndefined(this.model.country)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('selectcountry'));
      return;
    }
    this.onNextModal('productiveEquipment');
  }

  // STEP 5
  onStepSaveFive() {
    if (this.isNullOrUndefined(this.model.productiveEquipament)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('selectoption'));
      return;
    }
    if (this.model.productiveEquipament) {
      if (this.isNullOrUndefined(this.model.productiveDescription)) {
        this.showMessage(this.translate.instant('attention'), this.translate.instant('selectproceed'));
        return;
      }
    }
    this.onNextModal('responsibleArea');
  }

  // STEP 6
  onStepSaveSix() {
    const arrValidateFields = [
      {value: this.model.areaResponsible, text: 'Área Principal, <br />'},
      {value: this.model.areaExtensionLine, text: 'Ramal, <br />'},
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + `<br><br> ${stringError}`);
      return;
    }
    this.onNextModal('contact');
  }

  // STEP 7
  onStepSaveSeven() {
    const arrValidateFields = [
      {value: this.model.email, text: 'E-mail, <br />'},
      {value: this.modelEmailConfirm, text: 'Repita o e-mail, <br />'}
    ];
    const stringError = this.validateField(arrValidateFields);
    if (!super.isNullOrUndefined(stringError)) {
      this.showMessage(this.translate.instant('attention'), this.translate.instant('required') + `<br><br> ${stringError}`);
      return;
    }
    if (!this.isEMailValid(this.model.email)) {
      return;
    }
    if (this.model.email !== this.modelEmailConfirm) {
      super.showMessage(this.translate.instant('attention'), this.translate.instant('verify'));
      return;
    }

    $('#loaderBox').fadeIn();
    this.createIdeaGQL.mutate({data: this.model}).subscribe(
      async ({data}) => {
        // anexos só com sessão (o upload exige token); falha de um não impede os demais
        const results = this.hasSession && this.attachments.length && data?.createIdea?.id
          ? await this.ideaAttachmentService.uploadAll('idea', data.createIdea.id, this.attachments)
          : [];
        this.attachments = [];
        this.model = new CreateIdeaInput();
        this.modelAuthorDetail = {};
        this.modelEmailConfirm = null;
        this.modelExpectations = [
          {isSelect: false, expectation: 'finance', expectationDescription: ''},
          {isSelect: false, expectation: 'productive', expectationDescription: ''},
          {isSelect: false, expectation: 'sustainability', expectationDescription: ''}
        ];
        this.onNextModal('finish');
        this.eventbus.emit(new EmitEvent(Events.isUpdateIdea, true));
        $('#loaderBox').fadeOut();
        this.showAttachmentSummary(results);
      }, (err) => {
      }
    );
  }

  /** O cadastro público (sem login) não mostra anexos: o upload exige token. */
  get hasSession(): boolean {
    return !!sessionStorage.getItem('token');
  }

  private showAttachmentSummary(results) {
    const summary = this.ideaAttachmentService.summarize(results);
    if (summary) {
      this.showMessage(this.translate.instant('attachments.summaryTitle'), summary.html, summary.type);
    }
  }

  openModalAuthor(id: string) {
    if ((this.model.authors.length > 1)) {
      this.showMessage(this.translate.instant('attention'), 'Conforme política do Programa Clic, a ideia pode ter no máximo 3 autores');
      $('#' + id).modal('hide');
      return;
    } else {
      $('#' + id).modal('show');
    }
  }

  private getAreas() {
    this.areasQuery = this.getAreasGQL.watch();
    this.areasQuery.valueChanges.subscribe(({data}) => {
      this.areas = data.areas as Array<Area>;
    });
  }
}
